import { InjectionToken } from '@angular/core';
import type { Analytics as FirebaseAnalytics } from 'firebase/analytics';
import type { FirebaseApp } from 'firebase/app';
import type { Auth as FirebaseAuth } from 'firebase/auth';
import type { Firestore as FirebaseFirestore } from 'firebase/firestore';
import type { Functions as FirebaseFunctions } from 'firebase/functions';
import type { FirebasePerformance } from 'firebase/performance';
import type { FirebaseStorage } from 'firebase/storage';

export type Auth = FirebaseAuth;
export const Auth = new InjectionToken<FirebaseAuth>('firebase.auth');

export type Firestore = FirebaseFirestore;
export const Firestore = new InjectionToken<FirebaseFirestore>('firebase.firestore');

export type Functions = FirebaseFunctions;
export const Functions = new InjectionToken<FirebaseFunctions>('firebase.functions');

export type Storage = FirebaseStorage;
export const Storage = new InjectionToken<FirebaseStorage>('firebase.storage');

export type App = FirebaseApp;
export const App = new InjectionToken<FirebaseApp>('firebase.app');

export type Analytics = FirebaseAnalytics;
export const Analytics = new InjectionToken<FirebaseAnalytics>('firebase.analytics');

export type Performance = FirebasePerformance;
export const Performance = new InjectionToken<FirebasePerformance>('firebase.performance');
